import create from 'zustand';

interface ICodeItem {
  id: string;
  client: 'ADMIN' | 'MINI';
  code: string;
  group: string;
  name: string;
  productId: string;
  description: null | string;
  createdAt: Date;
  updatedAt: Date;
  deleted: number;
}

const useResourceCode = create<IResourceState>()(set => ({
  hasFetchedResourceCodes: false,
  setHasFetchedResourceCodes: (hasFetched: boolean) =>
    set(state => ({
      ...state,
      hasFetchedResourceCodes: hasFetched
    })),
  resourceCodes: [],
  setResourceCodes: (codes: ICodeItem[]) =>
    set(state => ({
      ...state,
      resourceCodes: codes
    })),
  firstRoutAtAvailableRoutes: '',
  setFirstRoutAtAvailableRoutes: (route: string) =>
    set(state => ({
      ...state,
      firstRoutAtAvailableRoutes: route
    }))
}));

export default useResourceCode;

export interface IResourceState {
  hasFetchedResourceCodes: boolean;
  setHasFetchedResourceCodes: (bol: boolean) => void;
  resourceCodes: ICodeItem[];
  setResourceCodes: (codes: ICodeItem[]) => void;
  firstRoutAtAvailableRoutes: string;
  setFirstRoutAtAvailableRoutes: (route: string) => void;
}
